module.exports = __webpack_public_path__ + "img/2.8682fd30.png";